module.exports = __webpack_public_path__ + "static/media/img86.023438d9.jpg";